import { useSelector } from 'react-redux';

import { makeSelectFeatureFlag } from '@/model/global/selectors';
import { FeatureFlags } from '@/model/global/types';

export default function useFlag(flag: FeatureFlags): boolean {
  return useSelector(makeSelectFeatureFlag(flag));
}
